import React from 'react';

const InfoIcon = ({ fill = '#6E6E71', fillOpacity = 0.5, className = '', ...props }) => {
  return (
    <svg
      className={className}
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.93608 15H11.9406V9H9.93608V15ZM10.9384 7C11.2223 7 11.4604 6.90417 11.6525 6.7125C11.8446 6.52083 11.9406 6.28333 11.9406 6C11.9406 5.71667 11.8446 5.47917 11.6525 5.2875C11.4604 5.09583 11.2223 5 10.9384 5C10.6544 5 10.4163 5.09583 10.2242 5.2875C10.0321 5.47917 9.93608 5.71667 9.93608 6C9.93608 6.28333 10.0321 6.52083 10.2242 6.7125C10.4163 6.90417 10.6544 7 10.9384 7ZM10.9384 20C9.55187 20 8.2489 19.7375 7.02945 19.2125C5.81001 18.6875 4.74926 17.975 3.84721 17.075C2.94515 16.175 2.23102 15.1167 1.70483 13.9C1.17863 12.6833 0.915527 11.3833 0.915527 10C0.915527 8.61667 1.17863 7.31667 1.70483 6.1C2.23102 4.88333 2.94515 3.825 3.84721 2.925C4.74926 2.025 5.81001 1.3125 7.02945 0.7875C8.2489 0.2625 9.55187 0 10.9384 0C12.3249 0 13.6278 0.2625 14.8473 0.7875C16.0667 1.3125 17.1275 2.025 18.0295 2.925C18.9316 3.825 19.6457 4.88333 20.1719 6.1C20.6981 7.31667 20.9612 8.61667 20.9612 10C20.9612 11.3833 20.6981 12.6833 20.1719 13.9C19.6457 15.1167 18.9316 16.175 18.0295 17.075C17.1275 17.975 16.0667 18.6875 14.8473 19.2125C13.6278 19.7375 12.3249 20 10.9384 20ZM10.9384 18C13.1768 18 15.0728 17.225 16.6263 15.675C18.1799 14.125 18.9566 12.2333 18.9566 10C18.9566 7.76667 18.1799 5.875 16.6263 4.325C15.0728 2.775 13.1768 2 10.9384 2C8.69993 2 6.80394 2.775 5.2504 4.325C3.69686 5.875 2.92009 7.76667 2.92009 10C2.92009 12.2333 3.69686 14.125 5.2504 15.675C6.80394 17.225 8.69993 18 10.9384 18Z"
        fill={fill}
        fillOpacity={fillOpacity}
      />
    </svg>
  );
};
export default InfoIcon;
